<div class="appLogo pointer gap" fxFlex="100" fxLayoutAlign="center center">

  <div *ngIf="type=='dark'; else normalImage">
    <a (click)="closeMenu()">

      <img [alt]="sitename" class="isa" fxFlex="100" fxLayoutAlign="center center" [src]="serverPath+'logo.png'"
        referrerpolicy="no-referrer"
        onerror="this.src='assets/images/error/logoerror1.png';this.style.width='200px';" />

    </a>
  </div>


  <ng-template #normalImage>

    <a (click)="closeMenu()">
      <img [alt]="sitename" class="isa" fxFlex="100" fxLayoutAlign="center center" [src]="serverPath+'logoBG.png'"
        referrerpolicy="no-referrer"
        onerror="this.src='assets/images/error/logoerror1.png';this.style.width='200px';" />
    </a>
  </ng-template>

</div>